import { Box, Container, Stack, Typography, useTheme, useMediaQuery } from '@mui/material'
import { ResultFooter, ResultsAccordion } from '../../subComponents'
import { ResultCta } from '../ResultFooter/ResultCta'
import { ResultsBreakdown } from '../ResultsBreakdown'

export const SuccessfulAnalysis = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const today = new Date()
  const formattedDate = today.toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  })

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.background.default,
        minHeight: 'calc(100vh - 68px)',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Container
        maxWidth="lg"
        sx={{
          pt: 4,
          pb: isMobile ? 8 : 5,
          px: isMobile ? '12px' : '70px !important',
        }}
      >
        <Stack spacing={3}>
          <Stack>
            <Typography
              fontSize={{xs: "2rem", md:"2.2rem"}}
              fontWeight={theme.typography.fontWeightBold}
              color='text.primary'
            >
              Water analysis results
            </Typography>
            <Typography fontSize={'1rem'} color={theme.palette.grey[600]}>
              Analysis completed on {formattedDate}
            </Typography>
          </Stack>
          <ResultsBreakdown />
          <ResultsAccordion />
        </Stack>
      </Container>
      <ResultCta />
      <Box sx={{ mt: 'auto' }}>
        <ResultFooter />
      </Box>
    </Box>
  )
}
